export default __webpack_public_path__ + "static/media/1_0136.0712fc78.webp";